// Opens a print-ready window for a single cocktail recipe.
export function printCocktail(c) {
  const win = window.open("", "_blank", "width=720,height=900");
  if (!win) return;
  const doc = win.document;
  const ingredients = c.ingredients.map(i => `<li>${escapeHtml(i)}</li>`).join("");
  const method = c.method.map(m => `<li>${escapeHtml(m)}</li>`).join("");
  const taste = (c.taste_profile || []).map(t => `<span class="chip">${escapeHtml(t)}</span>`).join("");

  doc.open();
  doc.write(`<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<title>${escapeHtml(c.name)} — Sip Alchemy</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap" rel="stylesheet">
<style>
  @page { size: A5; margin: 14mm; }
  * { box-sizing: border-box; }
  body { margin: 0; padding: 40px; background: #FAF7F2; color: #0D0D0D; font-family: 'Plus Jakarta Sans', sans-serif; }
  .card { max-width: 560px; margin: 0 auto; }
  .brand { font-family: 'Playfair Display', serif; font-style: italic; color: #E05A88; font-size: 14px; letter-spacing: 0.15em; text-transform: uppercase; font-weight: 600; }
  h1 { font-family: 'Playfair Display', serif; font-size: 42px; line-height: 1.05; margin: 8px 0 6px; font-weight: 700; }
  .sub { color: #6b6668; font-size: 14px; margin-bottom: 20px; }
  h2 { font-family: 'Playfair Display', serif; font-size: 11px; letter-spacing: 0.28em; text-transform: uppercase; margin: 24px 0 8px; color: #E05A88; font-weight: 700; }
  ul, ol { padding-left: 20px; margin: 0; }
  li { margin-bottom: 6px; line-height: 1.55; font-size: 14px; }
  .row { display: flex; flex-wrap: wrap; gap: 8px; margin: 12px 0 4px; }
  .chip { display: inline-block; font-size: 10px; letter-spacing: 0.12em; text-transform: uppercase; font-weight: 700; padding: 4px 10px; border-radius: 999px; background: #F4DDE5; color: #B93B6C; }
  .meta { display: flex; gap: 18px; font-size: 12px; color: #6b6668; border-top: 1px solid #DAD2C5; border-bottom: 1px solid #DAD2C5; padding: 12px 0; margin-top: 14px; }
  .meta b { display: block; color: #0D0D0D; font-family: 'Playfair Display', serif; font-size: 15px; font-weight: 700; }
  .tip { font-family: 'Playfair Display', serif; font-style: italic; color: #333; font-size: 14px; margin-top: 20px; padding: 14px 16px; border-left: 3px solid #E05A88; background: #fff; }
  .footer { margin-top: 32px; text-align: center; font-size: 10px; letter-spacing: 0.2em; text-transform: uppercase; color: #8a8385; }
  .footer strong { color: #E05A88; letter-spacing: 0.15em; }
  img { max-width: 100%; border-radius: 8px; margin-top: 16px; }
</style>
</head>
<body>
  <div class="card">
    <div class="brand">Sip Alchemy · Recipe Card</div>
    <h1>${escapeHtml(c.name)}</h1>
    <div class="sub">${escapeHtml(c.description || "")}</div>
    <div class="row">${taste}</div>
    <div class="meta">
      <div><b>${escapeHtml(c.base_spirit)}</b><span>Base Spirit</span></div>
      <div><b>${escapeHtml(c.strength)}</b><span>Strength</span></div>
      <div><b>${escapeHtml(c.abv || "")}</b><span>ABV</span></div>
      <div><b>${escapeHtml(c.glassware || "")}</b><span>Glassware</span></div>
    </div>
    <h2>Ingredients</h2>
    <ul>${ingredients}</ul>
    <h2>Method</h2>
    <ol>${method}</ol>
    ${c.pro_tip ? `<div class="tip"><b style="color:#E05A88;font-style:normal;font-family:'Plus Jakarta Sans';font-size:10px;letter-spacing:0.2em;text-transform:uppercase;">Pro Tip · </b>${escapeHtml(c.pro_tip)}</div>` : ""}
    <div class="footer">Poured with love by <strong>@SIP_ALCHEMY_</strong> · Drink Responsibly</div>
  </div>
  <script>
    window.onload = function() { setTimeout(function(){ window.print(); }, 350); };
  </script>
</body>
</html>`);
  doc.close();
}

function escapeHtml(s) {
  return String(s || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
